export default __webpack_public_path__ + "media/images/features/saga/car-7a319f4cf40dc81c72dd159c785eb49e.png";